import { QuickFiltersValueDisplayUses } from '../../types/quickFilters/QuickFiltersValueDisplayUses';
import { useCallback } from 'react';
import FormattedList from 'I18n/components/FormattedList';
import QuickFiltersTags from './QuickFiltersTags';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickFiltersStringValueDisplay = props => {
  const {
    condition,
    onValueDelete,
    use
  } = props;
  const onValueDeleteLocal = useCallback(valueToDelete => {
    const newValue = condition.value.filter(item => item !== valueToDelete);
    if (newValue.count()) {
      onValueDelete(condition.set('value', newValue));
    } else {
      onValueDelete();
    }
  }, [onValueDelete, condition]);
  const tags = condition.value.toArray().map(value => {
    return {
      value,
      label: value
    };
  });
  if (use === QuickFiltersValueDisplayUses.STRING) {
    return /*#__PURE__*/_jsx(FormattedList, {
      exclusive: true,
      children: tags.map(({
        label
      }) => /*#__PURE__*/_jsx("span", {
        children: label
      }, `quick-filter-string-${label}`))
    });
  }
  return /*#__PURE__*/_jsx(QuickFiltersTags, {
    tags: tags,
    onTagClose: onValueDeleteLocal
  });
};
export default QuickFiltersStringValueDisplay;